"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    linkButton: function linkButton(_ref2) {
      var disabled = _ref2.disabled;
      return {
        color: disabled ? palette.divider : palette.link.main,
        fontWeight: 'bold',
        cursor: disabled ? 'default' : 'pointer'
      };
    }
  };
});

var LinkButton = function LinkButton(_ref3) {
  var disabled = _ref3.disabled,
      className = _ref3.className,
      divProps = (0, _objectWithoutProperties2["default"])(_ref3, ["disabled", "className"]);
  var classes = useStyles({
    disabled: disabled
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.linkButton, className)
  }, divProps));
};

var _default = LinkButton;
exports["default"] = _default;